import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { includes, isEmpty } from 'ramda';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { codelistProvider, ComponentLoader } from 'components';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import TableHasNoResults from 'components/atoms/GefMui/TableHasNoResults';
import { useIgnoreErrorsWhen } from 'components/molecules/ComponentLoader/hooks';
import { codelists } from 'constants/codelists';
import { CONTACT_NOT_FOUND_ERR_MSG } from 'features/views/contactDetail/constants';
import { equalOrThreeDashes, fromIsoDateTime } from 'utils';
import { getCodelistPropById } from 'utils/codelists';

export const HistoryTable = ({ history, handleReload, fetchStorePath, solutionStates }) => {
	const ignoreErrorsForContactDetailNotFound = useIgnoreErrorsWhen({
		fetchStorePath,
		attributePath: ['metaData', 'parsedContent', 'message'],
		condition: (value) => includes(CONTACT_NOT_FOUND_ERR_MSG, value),
	});

	return (
		<ComponentLoader
			onReload={handleReload}
			fetchStorePath={fetchStorePath}
			ignoreErrors={ignoreErrorsForContactDetailNotFound}
		>
			<Paper sx={{ p: 3, borderRadius: 2 }}>
				<Stack spacing={2}>
					<SectionHeader text={getLabelMessage('contactDetail:contactHistorySubheader')} />
					<TableContainer>
						<Table size="small">
							<TableHead>
								<TableRow>
									<TableCell>{getLabelMessage('contactDetail:dateTIme')}</TableCell>
									<TableCell>{getLabelMessage('contactDetail:chengeMade')}</TableCell>
									<TableCell>{getLabelMessage('contactDetail:originalValue')}</TableCell>
									<TableCell>{getLabelMessage('contactDetail:newValue')}</TableCell>
									<TableCell>{getLabelMessage('contactDetail:solver')}</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{isEmpty(history) ? (
									<TableHasNoResults />
								) : (
									history.map((item, index) => (
										<TableRow key={index}>
											<TableCell>
												{equalOrThreeDashes(fromIsoDateTime(item.dateModified))}
											</TableCell>
											<TableCell>{equalOrThreeDashes(item.userModifiedLogin)}</TableCell>
											<TableCell>
												{equalOrThreeDashes(
													item.oldSolver
														? item.oldSolver
														: getCodelistPropById(
																item.oldStatus,
																solutionStates,
																'shortDescription',
														  ),
												)}
											</TableCell>
											<TableCell>
												{equalOrThreeDashes(
													item.newSolver
														? item.newSolver
														: getCodelistPropById(
																item.newStatus,
																solutionStates,
																'shortDescription',
														  ),
												)}
											</TableCell>
											<TableCell>
												{equalOrThreeDashes(
													item.currentSolver ? item.currentSolver : item.newSolver,
												)}
											</TableCell>
										</TableRow>
									))
								)}
							</TableBody>
						</Table>
					</TableContainer>
				</Stack>
			</Paper>
		</ComponentLoader>
	);
};

HistoryTable.propTypes = {
	fetchStorePath: PropTypes.string,
	handleReload: PropTypes.func,
	history: PropTypes.array,
	solutionStates: PropTypes.array,
};

export default codelistProvider(codelists.solutionState, 'solutionStates')(HistoryTable);
